var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("email-onboarding-domain", [
        _c("div", { staticClass: "flex-column" }, [
          _c("div", { staticClass: "flex-row mb-2" }, [
            _c("span", { staticClass: "grey bold fs-5" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Paramètres des emails /")) + " ")
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "m-0 ml-1 fs-5" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Authentification du domaine")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "link flex-level pb-1",
              on: {
                click: function($event) {
                  return _vm.backToSettingEmail()
                }
              }
            },
            [
              _c("i", { staticClass: "icon-chevron-left mr-1" }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Revenir aux paramètres des emails"))
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }